"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function unknownCommandError(cmd) {
    return new Error("I do not know command " + cmd);
}
exports.unknownCommandError = unknownCommandError;
//# sourceMappingURL=unknown-command.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/latex-to-unicode-converter/ts-compiled/unknown-command.js
// module id = 46
// module chunks = 0 1 2 3